import { createWebHistory, createRouter, type RouteRecordRaw, type Router } from 'vue-router';
import { installPermissionsRouterGuard } from 'app/src/shared/permissions/permissions-router-guard';
import RouteNames from './names';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: RouteNames.Home,
    redirect: () => {
      if (routerInstance.hasRoute(RouteNames.Exercises.List)) {
        return {
          name: RouteNames.Exercises.List,
          params: {
            page: '1',
            pageSize: '25',
          },
        };
      }
      return {
        name: RouteNames.Applications.TargetAssistance.Base,
      };
    },
    meta: {
      layout: 'DefaultLayout',
    },
  },
  {
    path: '/profile',
    name: RouteNames.UserProfile.Main,
    component: () => import('app/src/pages/profile/view'),
    redirect: () => {
      return {
        name: RouteNames.UserProfile.Notifications.Basic,
      };
    },
    meta: {
      layout: 'DefaultLayout',
      guard: true,
    },
    children: [
      {
        path: 'notifications',
        name: RouteNames.UserProfile.Notifications.Basic,
        redirect: () => {
          return {
            name: RouteNames.UserProfile.Notifications.List,
            params: {
              page: 1,
              pageSize: 10,
            },
          };
        },
        meta: {
          layout: 'DefaultLayout',
          guard: true,
        },
        children: [
          {
            path: ':pageSize/:page',
            name: RouteNames.UserProfile.Notifications.List,
            component: () => import('app/src/pages/profile/notifications'),
            meta: {
              layout: 'DefaultLayout',
              guard: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/applications',
    name: RouteNames.Applications.Base,
    redirect: () => {
      return {
        name: RouteNames.Applications.TargetAssistance.Base,
      };
    },
    children: [
      {
        path: 'target-assistance/:pageSize?/:page?',
        name: RouteNames.Applications.TargetAssistance.Base,
        component: () => import('app/src/pages/applications/targetAssistance'),
        meta: {
          layout: 'DefaultLayout',
          guard: true,
        },
        beforeEnter: (to) => {
          to.params = { pageSize: '25', page: '1' };
        },
      },
      {
        path: 'mutual-aid-board/:pageSize?/:page?',
        name: RouteNames.Applications.MutualAidBoard.Base,
        component: () => import('app/src/pages/applications/mutualAidBoard'),
        meta: {
          layout: 'DefaultLayout',
          guard: true,
        },
        beforeEnter: (to) => {
          to.params = { pageSize: '25', page: '1' };
        },
      },
      {
        path: 'become-volunteer/:pageSize?/:page?',
        name: RouteNames.Applications.BecomeVolunteer.Base,
        component: () => import('app/src/pages/applications/becomeVolunteer'),
        meta: {
          layout: 'DefaultLayout',
          guard: true,
        },
        beforeEnter: (to) => {
          to.params = { pageSize: '25', page: '1' };
        },
      },
      {
        path: 'help-with-task/:pageSize?/:page?',
        name: RouteNames.Applications.HelpWithTask.Base,
        component: () => import('app/src/pages/applications/helpWithTask'),
        meta: {
          layout: 'DefaultLayout',
          guard: true,
        },
        beforeEnter: (to) => {
          to.params = { pageSize: '25', page: '1' };
        },
      },
      {
        path: 'cooperation/:pageSize?/:page?',
        name: RouteNames.Applications.Cooperation.Base,
        component: () => import('app/src/pages/applications/cooperation'),
        meta: {
          layout: 'DefaultLayout',
          guard: true,
        },
        beforeEnter: (to) => {
          to.params = { pageSize: '25', page: '1' };
        },
      },
      {
        path: 'presents/:pageSize?/:page?',
        name: RouteNames.Applications.Presents.Base,
        component: () => import('app/src/pages/applications/presents'),
        meta: {
          layout: 'DefaultLayout',
          guard: true,
        },
        beforeEnter: (to) => {
          to.params = { pageSize: '25', page: '1' };
        },
      },
      {
        path: 'events/:pageSize?/:page?',
        name: RouteNames.Applications.Events.Base,
        component: () => import('app/src/pages/applications/events'),
        meta: {
          layout: 'DefaultLayout',
          guard: true,
        },
        beforeEnter: (to) => {
          to.params = { pageSize: '25', page: '1' };
        },
      },
    ],
  },
  {
    path: '/address-collections',
    name: RouteNames.AddressCollections.Base,
    redirect: () => {
      return {
        name: RouteNames.AddressCollections.List,
        params: {
          page: 1,
          pageSize: 25,
        },
      };
    },
    meta: {
      layout: 'DefaultLayout',
    },
    children: [
      {
        path: ':pageSize/:page',
        name: RouteNames.AddressCollections.List,
        component: () => import('app/src/pages/addressCollections/ui'),
        meta: {
          layout: 'DefaultLayout',
          guard: true,
        },
      },
    ],
  },
];


const routerInstance: Router = createRouter({
  history: createWebHistory(),
  routes,
});

installPermissionsRouterGuard(routerInstance);

export default routerInstance;
